import { Card } from 'antd';
import Table, { TableProps } from 'antd/lib/table';
import React from 'react';

// https://ant.design/components/tooltip/#API
// eslint-disable-next-line @typescript-eslint/no-explicit-any
interface ITable extends TableProps<any> {}

const TableComponent: React.FC<ITable> = props => {
    return (
        <Card
            style={{
                marginBottom: 10,
                marginTop: 10
            }}
            className="Table-card"
            bodyStyle={{
                padding: 6
            }}
        >
            <Table {...props} bordered={false} />
        </Card>
    );
};

export default TableComponent;
